
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/snowflake",
      function () {
        return require("private-next-pages/destinations/snowflake.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/snowflake"])
      });
    }
  